import type {PreviewConfiguration} from 'schema/types';
import type {PreviewPart, SeparatedPart} from 'schemaDefinition/types';
import {isIncludedPreviewPart} from './isPartExcluded';

/**
 * Filters out parts excluded or not included in config
 */
export const getFilteredSchemaParts = (
  parts: SeparatedPart[],
  config: PreviewConfiguration,
): PreviewPart[] => {
  return parts.reduce<PreviewPart[]>((acc, part) => {
    if (Array.isArray(part)) {
      const filteredRowParts = part.filter(p =>
        isIncludedPreviewPart(p, config),
      ) as PreviewPart[];

      if (filteredRowParts.length > 0) {
        acc.push(...filteredRowParts);
      }

      return acc;
    }

    if (isIncludedPreviewPart(part, config)) {
      acc.push(part);
    }

    return acc;
  }, []);
};
